<template>
  <el-select
    v-model="selectValue"
    :clearable="clearable"
    :placeholder="placeholder"
    :disabled="disabled"
    :multiple="multiple"
    @change="changeSelect"
  >
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: "Select-component",
  data() {
    return {
      selectValue: [],
    };
  },
  props: {
    list: {
      type: Array,
      validator: (list) => {
        return list.every(({ label, value }) => {
          return label && value;
        });
      },
      default: () => {
        return [];
      },
    },
    value: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.selectValue = this.value;
  },
  mounted() {},
  methods: {
    changeSelect(value) {
      this.$emit("input", value);
      this.$emit("change");
    },
  },
  watch: {
    value(val) {
      this.selectValue = val;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
